/* Carpet Signature — bandeau de réassurance (sections/cs-reassurance.liquid) : insertion dans le bloc « Badge de confiance » + texte toujours entier (réduction auto ou 2 lignes, réglable séparément ordinateur / mobile). */
(function(){
if(window.csReaInit)return;window.csReaInit=1;
function over(tx){for(var i=0;i<tx.length;i++){var t=tx[i],c=t.getBoundingClientRect().width;if(c>0&&t.scrollWidth-c>1)return true}return false}
function fit(){
document.querySelectorAll('.cs-rea').forEach(function(r){
var tx=r.querySelectorAll('.cs-rea__tx');if(!tx.length)return;
r.classList.remove('cs-rea--wrap','cs-rea--wrap-d');
tx.forEach(function(t){t.style.fontSize=''});
if(!r.hasAttribute('data-fit'))return;
var bp=parseInt(r.getAttribute('data-bp'),10)||749;
var mob=window.matchMedia('(max-width:'+bp+'px)').matches;
var min=parseFloat(r.getAttribute(mob?'data-fit':'data-fit-d'))||8;
if(!mob&&r.getAttribute('data-mode-d')==='wrap')r.classList.add('cs-rea--wrap-d');
var fs=parseFloat(getComputedStyle(tx[0]).fontSize),k=0;
while(over(tx)&&fs>min&&k<80){fs=Math.max(min,Math.round((fs-0.25)*100)/100);tx.forEach(function(t){t.style.fontSize=fs+'px'});k++}
if(over(tx)){r.classList.remove('cs-rea--wrap-d');r.classList.add('cs-rea--wrap')}
});
}
var ro=window.ResizeObserver?new ResizeObserver(function(es){var ch=false;es.forEach(function(e){var w=Math.round(e.contentRect.width);if(e.target._csW!==w){e.target._csW=w;ch=true}});if(ch)fit()}):null;
function go(force){
var tpl=document.getElementById('cs-rea-tpl');if(!tpl)return;
document.querySelectorAll('.trust-badge').forEach(function(t){
var old=t.querySelector('.cs-rea');
if(old&&force){old.remove();old=null}
if(!old){t.appendChild(tpl.content.cloneNode(true));var n=t.querySelector('.cs-rea');if(n&&ro)ro.observe(n)}
});
fit();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){go()});else go();
window.addEventListener('load',fit);
if(document.fonts&&document.fonts.ready)document.fonts.ready.then(fit);
var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(fit,100)});
document.addEventListener('shopify:section:load',function(){setTimeout(function(){go(true)},50)});
['shopify:block:select','shopify:block:deselect'].forEach(function(e){document.addEventListener(e,function(){setTimeout(function(){go()},50)})});
if(window.Shopify&&Shopify.designMode&&window.MutationObserver){new MutationObserver(function(){var n=document.querySelectorAll('.trust-badge').length,m=document.querySelectorAll('.trust-badge .cs-rea').length;if(n!==m)go()}).observe(document.body,{childList:true,subtree:true});}
})();
